<template>
  <v-layout style="overflow: hidden">
    <v-flex xs6 ml-4 mt-3>
      <v-layout column>
        <v-flex class="property"
          >クリエイティブID： {{ creative.anCreativeId }}</v-flex
        >
        <v-flex class="property">クリエイティブ種別： バナー（静止画）</v-flex>
        <v-flex class="property"
          >画像サイズ： {{ creative.width }}x{{ creative.height }}</v-flex
        >
        <v-flex class="property">
          遷移先URL：
          <a
            :href="creative.landingPageUrl"
            class="url"
            target="_blank"
            rel="noopener"
          >
            {{ creative.landingPageUrl }}
            <v-icon small>launch</v-icon>
          </a>
        </v-flex>
        <v-flex v-if="!hideStatus" class="property">
          ステータス：
          <AppStatus :value="creative.status" />
          <span v-if="creative.isExpired">
            （期限切れ）
          </span>
        </v-flex>
        <v-flex class="property">
          審査ステータス：
          <CreativeAnAuditStatus
            :anAuditStatus="creative.anAuditStatus"
            :status="creative.status"
          />
          <CreativeAuditFeedback
            v-if="!hideFeedbacks"
            :value="creative.anAuditFeedback"
            class="feedback mb-2"
          />
        </v-flex>
        <v-flex class="property">
          <div :style="{ position: 'relative' }">
            <v-menu open-on-hover bottom offset-y>
              <template v-slot:activator="{ on }">
                <a v-on="on" class="auditIcon">
                  <CreativeAuditIcon :creative="creative" />
                </a>
              </template>
              <v-card class="popover">
                <v-card-text>
                  Google 経由での配信は、プラットフォーム審査が承認済みかつ
                  Google 審査ステータスが承認済みの場合のみ配信されます。
                </v-card-text>
              </v-card>
            </v-menu>
            Google審査ステータス：
            <CreativeAnGoogleStatus :value="creative.anGoogleStatus" />
            <CreativeAuditFeedback
              v-if="!hideFeedbacks"
              :value="creative.anGoogleFeedback"
              class="feedback mb-2"
            />
          </div>
        </v-flex>
        <slot name="append" />
      </v-layout>
    </v-flex>
    <v-flex xs1>
      <v-spacer />
    </v-flex>
    <v-flex xs4 mr-4 mt-3>
      <BannerThumbnail
        :banner="creative"
        :max-width="360"
        :max-height="360"
        :width="creative.width"
        :height="creative.height"
        :droppable="false"
      />
    </v-flex>
    <v-flex xs1>
      <v-spacer />
    </v-flex>
  </v-layout>
</template>

<script>
import BannerThumbnail from './BannerThumbnail.vue'
import CreativeAuditFeedback from './CreativeAuditFeedback.vue'
import CreativeAuditIcon from './CreativeAuditIcon.vue'
import CreativeAnGoogleStatus from './CreativeAnGoogleStatus.vue'
import CreativeAnAuditStatus from './CreativeAnAuditStatus.vue'

export default {
  name: 'BannerDetail',
  components: {
    CreativeAnAuditStatus,
    CreativeAnGoogleStatus,
    CreativeAuditIcon,
    CreativeAuditFeedback,
    BannerThumbnail,
  },
  props: {
    creative: {
      type: Object,
      required: true,
    },
    hideFeedbacks: Boolean,
    hideStatus: Boolean,
  },
}
</script>

<style scoped>
.auditIcon {
  display: inline-block;
  position: absolute;
  width: 30px;
  left: -30px;
}

.property {
  margin-bottom: 0.5rem;
}

.popover {
  max-width: 300px;
}

.feedback {
  max-width: 450px;
  margin-left: 12px;
}

.url {
  word-wrap: break-word;
}
</style>
